module.exports = __webpack_public_path__ + "img/pro_seven_2.8c60c9bd.jpg";